
import Ventana from "../../../isp._comun/iu/_principal/reductores/Ventana";

export default class VentanaQueryPlanes extends Ventana {
    constructor() {
        super();
        this.ventanaCargando = null
    }

    puedeHacersePasarPor(ventanaAAbrir) {
        if (!(ventanaAAbrir instanceof VentanaQueryPlanes)) {
            return false;
        }

        return true;
    }

    clonar(){
        const nuevaVentana = new VentanaQueryPlanes();
        nuevaVentana.id              = this.id;
        nuevaVentana.posicionZ       = this.posicionZ         
        nuevaVentana.ventanaCargando = this.ventanaCargando
        return nuevaVentana;
    }
}
